import * as React from 'react';
export const bniSvg = React.forwardRef(function bniSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F15A23',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.563 0H32v9.857S28.656 7 25.749 7C22.03 7 20 10.203 20 12.525c0 3.384 1.628 5.264 3.263 6.894 2.348 2.343 5.206 4.87 8.737 2.836v1.316s-2.118 3.427-6.903 2.026c-3.651-1.069-6.8-5.597-6.8-5.597L15 22.975s2.816 4.049 4.6 5.399c3.024 2.288 4.26 1.388 4.26 1.388L21.49 32H17l-5.313-6L4 32H0l10-7.93L0 12V5.042l2.483 3.153L12.692 21 16 18.356s-2.746-3.246-4.59-6.867C7.804 4.409 10.357 0 10.357 0h5.206Zm0 0L32 .023V4.47s-5.496-3.034-10.345 2.063c-2.275 2.39-2.477 6.465-2.477 6.465.008.092-3.125-4.011-3.913-7.888-.737-3.628.298-5.11.298-5.11Z',
      fill: '#fff',
    }),
  );
});
bniSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bni = {
  category: 'brand',
  colorable: false,
  name: 'bni',
  svg: bniSvg,
};
